import React, { useEffect, useState } from 'react';
import { mapData } from './mapData';
import court from '../../Images/about.svg'
import { ArrowRight, EmailOutlined, LocationOnOutlined, PhoneOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MapFooter = () => {
  const [selectedEtrap, setSelectedEtrap] = useState(null);
  const [selectedVelayat, setSelectedVelayat] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null)
  const [lng, setLng] = useState(null);
  const [lat, setLat] = useState(null);
  const { t } = useTranslation()

  useEffect(() => {
    if (selectedEtrap) {
      setLat(selectedEtrap.coords[0]);
      setLng(selectedEtrap.coords[1]);
    } else if (selectedCity) {
      setLat(selectedCity.coords[0]);
      setLng(selectedCity.coords[1]);
    } else if (selectedVelayat) {
      setLat(selectedVelayat.coords[0]);
      setLng(selectedVelayat.coords[1]);
    }
  }, [selectedEtrap, selectedCity, selectedVelayat]);

  const handleEtrapClick = (etrap) => {
    setSelectedVelayat(null)
    setSelectedCity(null)
    setSelectedEtrap(etrap);
    setLat(etrap.coords[0]);
    setLng(etrap.coords[1]);
    const velayat = mapData.velayats.find(v => v.etraps.some(e => e.id === etrap.id));
    setSelectedVelayat(velayat);
  };

  const handleCityClick = (city) => {
    if (city && city.id) {
      const velayat = mapData.velayats.find(v => v.cities && v.cities.some(e => e.id === city.id));
      if (velayat) {
        setSelectedVelayat(velayat);
        setSelectedEtrap(null);
        setSelectedCity(city);
        setLat(city.coords[0]);
        setLng(city.coords[1]);
      } else {
        console.error('Velayat not found for the city');
      }
    } else {
      console.error('Invalid city object');
    }
  };

  const handleSelectVelayatChange = (velayatId) => {
    const velayat = mapData.velayats.find(v => v.id === velayatId);
    if (velayat) {
      setSelectedVelayat(velayat);
      setSelectedEtrap(null);
      setSelectedCity(null);
      setLat(null);
      setLng(null);
    } else {
      console.error('Velayat not found');
    }
  };

  return (
    <div className="mt-8 pb-12 media dark:bg-dark-box
                    border-b border-b-border">
      <div className='flex justify-between pb-2 border-b dark:pt-4
                     border-b-border  dark:border-dark-border'>
        <h1 className='text-xl xl:text-2xl font-bold dark:text-dark-text'>
          {t('branches')}
        </h1>
        <Link
          to='/map'
          className='font-bold text-primary flex items-center
                     dark:text-dark-text'
        >
          {t('all_button')}
          <ArrowRight />
        </Link>
      </div>
      <div className="lg:flex gap-4 justify-between items-center">
        <section className="lg:w-[60%] h-full p-2">
          <div className='w-full h-full flex items-center'>
            <svg
              viewBox="0 0 29700 21000"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: 'auto' }}
            >
              {mapData?.velayats?.map(velayat => (
                <g key={velayat.id}>
                  <path
                    id={velayat.id}
                    d={velayat.path}
                    fill={
                      velayat.id === 'ashgabat'
                        ? '#003aa6ca'
                        : selectedVelayat?.id === velayat.id
                          ? '#003aa6ca'
                          : 'rgba(0, 0, 0, 0)'
                    }
                    stroke='rgba(0, 98, 130, 0.93)'
                    strokeWidth="70"
                    onClick={() => handleSelectVelayatChange(velayat.id)}
                  />

                  {velayat?.etraps?.map(etrap => (
                    <g
                      key={etrap.id}
                      onClick={() => handleEtrapClick(etrap)}
                      style={{ cursor: 'pointer' }}
                    >
                      <path
                        id={etrap.id}
                        d={etrap.path}
                        fill={selectedEtrap?.id === etrap.id ? '#0039a6'
                          : 'rgba(171, 182, 201, 0.7)'}
                        stroke="#fff"
                        strokeWidth="20"
                      />
                    </g>
                  ))}

                  {velayat?.cities?.map(city => (
                    <g
                      key={city.id}
                      onClick={() => handleCityClick(city)}
                      style={{ cursor: 'pointer' }}
                    >
                      <circle
                        id={city.id}
                        cx={city.cx}
                        cy={city.cy}
                        r="210"
                        fill={selectedCity?.id === city.id ? '#0039a6' : '#c3c3c300'}
                      />
                    </g>
                  ))}
                </g>
              ))}
            </svg>
          </div>
        </section>

        <section className='lg:w-[50%] p-4 h-full'>
          {lng && lat ?
            <>
              <h1 className='text-center mb-8 text-primary font-bold text-xl dark:text-dark-text'>
                {selectedCity?.name || selectedEtrap?.name || selectedVelayat?.name || ''}
              </h1>
              <div className='w-full h-full'>
                <ul className='space-y-2 mb-4 dark:text-dark-text'>
                  <li>
                    <PhoneOutlined className='text-primary dark:text-dark-text' />
                    : {selectedCity?.phone || selectedEtrap?.phone || selectedVelayat?.phone || ''}
                  </li>
                  <li>
                    <EmailOutlined className='text-primary dark:text-dark-text' />
                    : {selectedCity?.email || selectedEtrap?.email || selectedVelayat?.email || ''}
                  </li>
                  <li>
                    <LocationOnOutlined className='text-primary dark:text-dark-text' />
                    :  {selectedCity?.address || selectedEtrap?.address || selectedVelayat?.address || ''}
                  </li>
                </ul>
                {lng && lat && (
                  <div className="w-[100%] h-56 lg:h-80">
                    <iframe
                      title='Map'
                      name="frame"
                      src={`https://maps.google.com/maps?q=${lat},${lng}&hl=es;z=15&output=embed`}
                      frameBorder="0"
                      style={{ border: "0", width: "100%", height: "100%", position: "relative" }}
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
              </div>
            </> :
            <>
              <h1 className='text-center mb-8 text-primary font-bold text-xl'>
                {t('supreme_court')} {t('turkmenistan')}
              </h1>
              <ul className='space-y-2 mb-4 dark:text-dark-text'>
                <li>
                  <PhoneOutlined className='text-primary' />
                  : +993 12 38-09-32
                </li>
                <li>
                  <EmailOutlined className='text-primary' />
                  :  yokarykazyyet@court.gov.tm
                </li>
                <li>
                  <LocationOnOutlined className='text-primary' />
                  :  Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy
                </li>
              </ul>
              <img src={court} alt="court" className='object-contain h-[70%]' />
            </>
          }
        </section>
      </div>
    </div>
  );
};

export default MapFooter;
